import type { FC, HTMLProps } from 'react';
import { css } from '@emotion/react';
import { Typography, TypographyProps } from 'client/components/Typography';

const listItemStyle = css`
  flex: 1;

  > p {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`;

export interface ListItemTextProps extends HTMLProps<HTMLDivElement> {
  primary: string | JSX.Element;
  primaryProps?: TypographyProps;
  secondary?: string | JSX.Element | null | false;
  secondaryProps?: TypographyProps;
}

export const ListItemText: FC<ListItemTextProps> = ({ primary, primaryProps, secondary, secondaryProps, ...other }) => {
  return (
    <div css={listItemStyle} {...other}>
      <Typography {...primaryProps}>{primary}</Typography>
      {secondary && (
        <Typography variant="body2" component="span" {...secondaryProps}>
          {secondary}
        </Typography>
      )}
    </div>
  );
};
